import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Modal,
  Tabs,
  Tab,
  Table,
  Spinner,
} from "react-bootstrap";
import { useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import Paginations from "../../components/pagination";
import MenuDropdown from "../../components/dropdownmenu";
import Breadcrumbs from "../../components/breadcrumbs";
import { useNavigate } from "react-router-dom";
import GeneratedQuestions from "../../components/vdfndr_generated_questions";
import QuestionRegenerateForm from "../../components/question-regenerate-form";
import RegeneratedQuestions from "../../components/regenerated-questions";
import { useAccess } from "../../contexts/AccessContext";
import { isAdminRole } from "../../shared/utils";

const SavedListTable = () => {
  const [parentCheck, setParentCheck] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [paginationData, setPaginationData] = useState([]);
  const [selectedRow, setSelectedRow] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [apiResponse, setApiResponse] = useState("");
  const [deleteModel, setDeleteModel] = useState(false);
  const [visibleCharacters, setVisibleCharacters] = useState(2000);
  const [searchQuery, setSearchQuery] = useState();
  const [videoTitle, setVideoTitle] = useState();
  const [courseId, setCourseId] = useState();
  const [categoryId, setCategoryId] = useState();
  const [unitId, setUnitId] = useState();
  const [lessonId, setLessonId] = useState();
  const [channelName, setChannelName] = useState();
  const [searchType, setSearchType] = useState(0);
  const [courseArray, setCourseArray] = useState([]);
  const [catArray, setCatArray] = useState([]);
  const [unitArray, setUnitArray] = useState([]);
  const [showSpinner, setShowSpinner] = useState(false);
  const [clickPage, setClickPage] = useState(1);
  const [deletedisable, setDeleteDisable] = useState(true);
  const [lessonArray, setLessonArray] = useState([]);

  const savedVideoListTableToolId = 1;
  const { hasEdit } = useAccess();
  const isAdmin = useMemo(() => isAdminRole(), []);

  const navigate = useNavigate();
  const cellStyle = {
    maxWidth: "100px" /* Set your preferred max-width */,
    whiteSpace: "nowrap" /* Prevent text wrapping */,
    overflow: "hidden" /* Hide overflowing content */,
    textOverflow: "ellipsis" /* Show ellipsis for truncated content */,
  };
  useEffect(() => {
    // Session validation: ensure the user is still authenticated via OAuth2.
    const isLoggedIn = localStorage.getItem("login");
    if (isLoggedIn !== "true") {
      navigate("/");
    }
  }, [navigate]);
  const getApicall = () => {
    setShowSpinner(true);
    setTableData([]);
    const url = `${process.env.REACT_APP_API_URL}/video-finder?page=` + clickPage;
    axios
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json", // You can set the Accept header if needed
        },
      })
      .then((response) => {
        setPaginationData(response.data.page_data);
        setTableData(response.data.data);
        setSelectedRow([]);
        setParentCheck(false);
        setShowSpinner(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  useEffect(() => {
    if (
      searchQuery ||
      courseId ||
      unitId ||
      videoTitle ||
      channelName ||
      lessonId ||
      searchType != 0
    ) {
      handleSearch(true);
    } else {
      getApicall();
    }
  }, [clickPage]);
  useEffect(() => {
    if (parentCheck || selectedRow.length > 0) {
      setDeleteDisable(false);
    } else {
      setDeleteDisable(true);
    }
  }, [parentCheck, selectedRow]);
  const handleCheck = (checked, id) => {
    if (checked) {
      const temp = [...selectedRow, id];
      setSelectedRow(temp);
    } else {
      const temp = selectedRow.filter((val) => val !== id);
      setSelectedRow(temp);
    }
  };
  const handleParentCheck = (checked) => {
    if (checked) {
      setParentCheck(true);
    } else {
      setParentCheck(false);
      setSelectedRow([]);
    }
  };
  const handleDeleteClick = () => {
    if (parentCheck) {
      for (var i = 0; i < tableData.length; i++) {
        var currentId = tableData[i].id;
        if (selectedRow.indexOf(currentId) === -1) {
          selectedRow.push(currentId);
        }
      }
    }
    setDeleteModel(true);
  };
  const handleDelete = () => {
    const url = `${process.env.REACT_APP_API_URL}/video-finder?ids=${JSON.stringify(selectedRow)}`;
    axios
      .delete(url)
      .then((response) => {
        setSelectedRow([]);
        setDeleteModel(false);
        getApicall();
        toast.error("Deleted successfully");
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  const modalClick = (id) => {
    setIsOpen(true);
    setQuestionsState();
    setActiveQuestionTab("old_questions");
    setApiResponse("");
    const url = `${process.env.REACT_APP_API_URL}/video-finder?id=${id}`;
    axios
      .put(url, {
        headers: {
          Accept: "application/json", // You can set the Accept header if needed
        },
      })
      .then((response) => {
        setApiResponse(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  const closePopup = () => {
    setIsOpen(false);
  };
  const handleShowMore = (transcriptLength) => {
    setVisibleCharacters(
      (prevVisibleCharacters) => prevVisibleCharacters + (transcriptLength - prevVisibleCharacters),
    ); // Increment by 200 characters
  };
  useEffect(() => {
    // if(categoryId==0||categoryId===null){
    //     setCourseArray([]);
    // }else{
    axios
      .post(
        "https://" +
          process.env.REACT_APP_LMS_URL +
          "/webservice/rest/server.php?wstoken=" +
          process.env.REACT_APP_LMS_TOKEN +
          "&wsfunction=local_course_service_get_category_list&moodlewsrestformat=json",
      )
      .then((response) => {
        if (response.data) {
          const { data } = response.data;
          // console.log("decodedData",data)
          setCatArray(data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
    // }
  }, []);
  useEffect(() => {
    if (categoryId) {
      axios
        .post(
          "https://" +
            process.env.REACT_APP_LMS_URL +
            "/webservice/rest/server.php?wstoken=" +
            process.env.REACT_APP_LMS_TOKEN +
            "&wsfunction=local_course_service_course_data&moodlewsrestformat=json&user_id=0&category_id=" +
            categoryId,
        )
        .then((response) => {
          setCourseArray(response.data.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      setCourseArray([]);
    }
  }, [categoryId]);

  useEffect(() => {
    if (courseId) {
      axios
        .post(
          "https://" +
            process.env.REACT_APP_LMS_URL +
            "/webservice/rest/server.php?wstoken=" +
            process.env.REACT_APP_LMS_TOKEN +
            "&wsfunction=local_course_service_course_unit_data&moodlewsrestformat=json&course_id=" +
            courseId,
        )
        .then((response) => {
          if (response.data) {
            const decodedData = JSON.parse(response.data.data);
            let units = decodedData[0].units;
            setUnitArray(validateUnits(units));
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      setUnitArray([]);
    }
  }, [courseId]);
  useEffect(() => {
    axios
      .post(
        "https://" +
          process.env.REACT_APP_LMS_URL +
          "/webservice/rest/server.php?wstoken=" +
          process.env.REACT_APP_LMS_TOKEN +
          "&wsfunction=local_course_service_unit_lessions_data&moodlewsrestformat=json&unit_id=" +
          unitId,
      )
      .then((response) => {
        if (response.data) {
          setLessonArray(response.data.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [unitId]);
  const handleSearch = (status) => {
    let search_dict = {};
    if (searchQuery) {
      search_dict["search_name"] = searchQuery;
    }
    if (categoryId) {
      search_dict["category_id"] = categoryId;
    }
    if (courseId) {
      search_dict["course_id"] = courseId;
    }
    if (unitId) {
      search_dict["unit_id"] = unitId;
    }
    if (videoTitle) {
      search_dict["video_title"] = videoTitle;
    }
    if (channelName) {
      search_dict["channel_title"] = channelName;
    }
    if (lessonId) {
      search_dict["lesson_id"] = lessonId;
    }
    if (searchType != 0) {
      search_dict["search_type"] = searchType;
    }
    let page = 1;
    let page_size = 10;
    let data = {
      search_dict: search_dict,
      page: status && clickPage ? clickPage : page,
      page_size: page_size,
    };
    const url = `${process.env.REACT_APP_API_URL}/video-finder`;
    axios
      .post(url, data, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json", // You can set the Accept header if needed
        },
      })
      .then((response) => {
        setPaginationData(response.data.page_data);
        setTableData(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  const handleReset = () => {
    axios
      .post(
        "https://" +
          process.env.REACT_APP_LMS_URL +
          "/webservice/rest/server.php?wstoken=" +
          process.env.REACT_APP_LMS_TOKEN +
          "&wsfunction=local_course_service_course_data&moodlewsrestformat=json",
      )
      .then((response) => {
        setCourseArray(response.data.data);
        setCategoryId("");
        setSearchQuery("");
        setCourseId("");
        setUnitId("");
        setVideoTitle("");
        setChannelName("");
        setLessonId("");
        setSearchType(0);
      });
  };
  const validateUnits = (data) => {
    const temp = data.slice();
    const val = temp.filter((unit) => unit.name.trim() !== "" && unit.name != ".");
    return val;
  };
  const title = useMemo(() => {
    return [
      {
        title: (
          <Form.Group controlId="subscriptionall">
            <Form.Check
              checked={parentCheck}
              type="checkbox"
              id="subscriptionall"
              onChange={(e) => {
                handleParentCheck(e.target.checked);
              }}
            />
          </Form.Group>
        ),
      },
      {
        title: "Search Query",
      },
      {
        title: "Video Title",
      },
      {
        title: "Course",
      },
      {
        title: "Unit",
      },
      {
        title: "Lesson",
      },
      {
        title: "Video URL",
      },
      {
        title: "Channel",
      },
      {
        title: " Views",
      },
      {
        title: " Likes",
      },
      {
        title: " Duration",
      },
      {
        title: "Relevancy Score",
      },
      {
        title: "Type",
      },
      {
        title: "Action",
      },
    ];
  }, [parentCheck]);

  const [questionsState, setQuestionsState] = useState();
  const [activeQuestionTab, setActiveQuestionTab] = useState("old_questions");
  const regeneratedQuestionsRef = useRef();

  return (
    <Container fluid className="p-4">
      <Breadcrumbs />
      <p className="section-title mb-5">Videos</p>
      <Form className="form-column">
        <Row>
          <Col className="mb-3" xs="11">
            <Row>
              <Col>
                {catArray && (
                  <Form.Select
                    aria-label="Default select example"
                    value={categoryId}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        handleSearch(false);
                      }
                    }}
                    onChange={(e) => setCategoryId(e.target.value !== "0" ? e.target.value : null)}
                  >
                    <option value="0">Select Category</option>
                    {catArray.map((course) => (
                      <option key={course.Category_ID} value={course.Category_ID}>
                        {course.Category_Name}
                      </option>
                    ))}
                  </Form.Select>
                )}
              </Col>
              <Col>
                {courseArray && (
                  <Form.Select
                    aria-label="Default select example"
                    value={courseId}
                    onChange={(e) => setCourseId(e.target.value !== "0" ? e.target.value : null)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        handleSearch(false);
                      }
                    }}
                  >
                    <option value="0">Select Course</option>
                    {courseArray.map((course) => (
                      <option key={course.Course_ID} value={course.Course_ID}>
                        {course.Course_Name}
                      </option>
                    ))}
                  </Form.Select>
                )}
              </Col>
              <Col>
                {unitArray && (
                  <Form.Select
                    aria-label="Default select example"
                    value={unitId}
                    onChange={(e) => setUnitId(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        handleSearch(false);
                      }
                    }}
                  >
                    <option>Select Unit</option>
                    {unitArray.map((unit) => (
                      <option key={unit.id} value={unit.id}>
                        {unit.name}
                      </option>
                    ))}
                  </Form.Select>
                )}
              </Col>
              <Col>
                <Form.Group controlId="unit" className="d-flex align-items-center pb-2">
                  {courseArray && (
                    <Form.Select
                      aria-label="Default select example"
                      onChange={(e) => setLessonId(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          handleSearch(false);
                        }
                      }}
                    >
                      <option>Select Lesson</option>
                      {lessonArray &&
                        lessonArray.map((lesson) => (
                          <option key={lesson.Id} value={lesson.Id}>
                            {lesson.Lession_Name}
                          </option>
                        ))}
                    </Form.Select>
                  )}
                </Form.Group>
              </Col>
              <Col>
                <Form.Group controlId="search" className="d-flex align-items-center">
                  <Form.Control
                    type="text"
                    autoComplete="off"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="search query"
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        handleSearch(false);
                      }
                    }}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group controlId="search" className="d-flex align-items-center">
                  <Form.Control
                    type="text"
                    autoComplete="off"
                    value={videoTitle}
                    onChange={(e) => setVideoTitle(e.target.value)}
                    placeholder="Video title"
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        handleSearch(false);
                      }
                    }}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group controlId="search" className="d-flex align-items-center">
                  <Form.Control
                    type="text"
                    autoComplete="off"
                    value={channelName}
                    onChange={(e) => setChannelName(e.target.value)}
                    placeholder="Channel name"
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        handleSearch(false);
                      }
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mt-3" style={{ alignItems: "center" }}>
              <Col>
                <Form.Group controlId="search" className="d-flex align-items-center">
                  <Form.Check
                    type="checkbox"
                    // className="ps-5"
                    id="newSearch"
                    value={searchType}
                    label="New search"
                    onChange={() => (searchType == 1 ? setSearchType(0) : setSearchType(1))}
                    checked={searchType == 1}
                  />
                  <Form.Check
                    type="checkbox"
                    className="ps-5"
                    id="replacementSearch"
                    value={searchType}
                    label="Replacement search"
                    onChange={() => (searchType == 2 ? setSearchType(0) : setSearchType(2))}
                    checked={searchType == 2}
                  />
                </Form.Group>
              </Col>
              <Col className="d-flex gap-2" style={{ justifyContent: "flex-end" }}>
                <div>
                  <Button
                    variant="outline-secondary"
                    type="button"
                    className=""
                    onClick={() => {
                      getApicall();
                      handleReset();
                    }}
                  >
                    Clear
                  </Button>
                </div>
                <div>
                  <Button
                    variant="primary"
                    type="button"
                    className=""
                    onClick={() => {
                      handleSearch(false);
                    }}
                    disabled={
                      !categoryId &
                      !courseId &
                      !unitId &
                      !videoTitle &
                      !searchQuery &
                      !channelName &
                      (searchType == 0)
                    }
                  >
                    Search
                  </Button>
                </div>
              </Col>
            </Row>
          </Col>
          {tableData.length ? (
            <>
              <div className="saved-list-table">
                <Col className="text-start" xs="12">
                 {(isAdmin || hasEdit(savedVideoListTableToolId)) &&  
                  <Button
                    variant="link"
                    type="button"
                    className="px-0 delete-link"
                    onClick={() => {
                      handleDeleteClick();
                    }}
                    disabled={deletedisable}
                  >
                    <div className="d-flex align-items center gap-1">
                      <img src={"/images/trash.svg"} alt="delete" />
                      Delete
                    </div>
                  </Button>
                }
                </Col>
                <Table responsive>
                  <thead>
                    <tr>
                      {title.map((val, index) => (
                        <th key={index}>{val.title}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {tableData &&
                      tableData.map((cd, rowIndex) => (
                        <tr key={cd?.video_id ?? `row-${rowIndex}`}>
                          <td>
                            <Form.Group controlId="subscription">
                              <Form.Check
                                type="checkbox"
                                id={cd.id}
                                checked={selectedRow.includes(cd.id) || parentCheck ? true : false}
                                onChange={(e) => {
                                  handleCheck(e.target.checked, cd.id);
                                }}
                                disabled={parentCheck}
                              />
                            </Form.Group>
                          </td>
                          <td className="text-start" style={cellStyle}>
                            <a
                              data-tooltip-id="my-tooltip"
                              data-tooltip-content={cd.search_name}
                              data-tooltip-place="top"
                            >
                              {cd.search_name}
                            </a>
                          </td>
                          <td style={cellStyle}>
                            <a
                              data-tooltip-id="my-tooltip"
                              data-tooltip-content={cd.video_title}
                              data-tooltip-place="top"
                            >
                              {cd.video_title}
                            </a>
                          </td>
                          <td className="text-start" style={cellStyle}>
                            <a
                              data-tooltip-id="my-tooltip"
                              data-tooltip-content={cd.course_name}
                              data-tooltip-place="top"
                            >
                              {cd.course_name}
                            </a>
                          </td>
                          <td style={cellStyle}>
                            <a
                              data-tooltip-id="my-tooltip"
                              data-tooltip-content={cd.unit_title}
                              data-tooltip-place="top"
                            >
                              {cd.unit_title}
                            </a>
                          </td>
                          <td style={cellStyle}>
                            <a
                              data-tooltip-id="my-tooltip"
                              data-tooltip-content={cd.lesson_name}
                              data-tooltip-place="top"
                            >
                              {cd.lesson_name}
                            </a>
                          </td>
                          <td style={cellStyle}>
                            <a href={cd.video_url} target="_blank">
                              {cd.video_url}
                            </a>
                          </td>
                          <td className="text-start" style={cellStyle}>
                            <a
                              data-tooltip-id="my-tooltip"
                              data-tooltip-content={cd.channel_title}
                              data-tooltip-place="top"
                            >
                              {cd.channel_title}
                            </a>
                          </td>
                          <td style={cellStyle}>{cd.views}</td>
                          <td style={cellStyle}>{cd.likes}</td>
                          <td style={cellStyle}>{cd.duration}</td>
                          <td style={cellStyle}>
                            {cd.relevancy_score ? cd.relevancy_score : "In progress.."}
                          </td>
                          <td style={cellStyle}>{cd.search_type == 1 ? "New" : "Replacement"}</td>
                          <td>
                            {" "}
                            <MenuDropdown
                              clickfunction={modalClick}
                              reloadfunction={getApicall}
                              id={cd.id}
                              video_url={cd.video_url}
                              category_id={cd.category_id}
                              isAdmin={isAdmin}
                              hasEdit={hasEdit(savedVideoListTableToolId)}
                            />
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </div>
            </>
          ) : (
            <></>
          )}
        </Row>
        <Row>
          <Col className="d-flex justify-content-start disabled">
            Displaying {tableData.length} of {paginationData.total_records} Records
          </Col>
          <Col className="d-flex justify-content-end">
            <Paginations
              current_page={paginationData.current_page}
              page_size={paginationData.page_size}
              total_page={paginationData.total_page}
              total_records={paginationData.total_records}
              clicked_page={setClickPage}
            />
          </Col>
        </Row>
        <Row>
          <Col xs="12">
            <Button
              hidden={!showSpinner}
              variant="link"
              className="mt-2 mb-5 btn-spinner ms-0 text-decoration-none"
              disabled
            >
              <Spinner
                as="span"
                animation="grow"
                size="sm"
                role="status"
                aria-hidden="true"
                className="me-1"
              />
            </Button>
          </Col>
        </Row>
      </Form>
      {isOpen && (
        <div className="modal">
          <div
            className="modal-content modal-xxl"
            style={{ maxHeight: "650px", minHeight: "650px", overflowY: "auto" }}
          >
            <span className="close" onClick={closePopup}>
              &times;
            </span>
            <center className="mb-4">
              <h2>{apiResponse.course_name}</h2>
            </center>
            <h4 className="mb-4">{apiResponse.unit_title}</h4>
            <Modal.Body>
              <Tabs defaultActiveKey="questions" id="nav-tabs">
                <Tab eventKey="questions" title="Questions">
                  {apiResponse.questions && apiResponse.process_status == "COMPLETED" ? (
                    <div className="content text-start mt-2">
                      {apiResponse.search_type == 1 ? (
                        <>
                          <h5 className="mb-3">Questions From Transcript</h5>
                          {questionsState === "not_generated" ? (
                            <QuestionRegenerateForm
                              type={"new"}
                              id={apiResponse.id}
                              onSubmit={() => {
                                setQuestionsState("generating");
                                regeneratedQuestionsRef.current?.loadData();
                              }}
                            />
                          ) : questionsState === "generating" ? (
                            <RegeneratedQuestions
                              id={apiResponse.id}
                              ref={regeneratedQuestionsRef}
                            />
                          ) : (
                            <GeneratedQuestions
                              id={apiResponse.id}
                              onDataLoad={(data) => {
                                if (data.length === 0) {
                                  setQuestionsState("not_generated");
                                }
                              }}
                            />
                          )}
                        </>
                      ) : (
                        <>
                          <h5 className="mb-3">Questions Relavancy - Course Content</h5>
                          {apiResponse.generated_question ? (
                            <>
                              <Tabs
                                activeKey={activeQuestionTab}
                                onSelect={setActiveQuestionTab}
                                id="question-nav-tabs"
                              >
                                <Tab eventKey="old_questions" title="Old Questions">
                                  {(() => {
                                    const allQuizDetails = apiResponse.questions
                                      ? apiResponse.questions.flatMap((q) => q.quiz_details || [])
                                      : [];
                                    let type = "new";
                                    if (allQuizDetails.length > 0) {
                                      const allCovered = allQuizDetails.every(
                                        (q) => q.covered === true || q.covered === "True",
                                      );
                                      const someCovered = allQuizDetails.some(
                                        (q) => q.covered === true || q.covered === "True",
                                      );
                                      if (allCovered) {
                                        type = "complete";
                                      } else if (someCovered) {
                                        type = "partial";
                                      } else {
                                        type = "none";
                                      }
                                    }
                                    return (
                                      <QuestionRegenerateForm
                                        type={type}
                                        id={apiResponse.id}
                                        onSubmit={() => {
                                          setActiveQuestionTab("new_questions");
                                          regeneratedQuestionsRef.current?.loadData();
                                        }}
                                      />
                                    );
                                  })()}
                                  {apiResponse.questions?.map((item, index) =>
                                    item.quiz_details?.map((element, indx) => (
                                      <div key={`${index}-${indx}`}>
                                        <h6>
                                          {element.question_text} {`( ${element.question_name} )`}
                                        </h6>
                                        <p className="mb-5">
                                          <b style={{ fontStyle: "italic" }}>Covered: </b>
                                          {element.covered || element.covered == "True"
                                            ? "Yes"
                                            : "No"}
                                        </p>
                                      </div>
                                    )),
                                  )}
                                </Tab>
                                <Tab eventKey="new_questions" title="New Questions">
                                  <RegeneratedQuestions
                                    id={apiResponse.id}
                                    ref={regeneratedQuestionsRef}
                                  />
                                </Tab>
                              </Tabs>
                            </>
                          ) : (
                            <>
                              {(() => {
                                const allQuizDetails = apiResponse.questions
                                  ? apiResponse.questions.flatMap((q) => q.quiz_details || [])
                                  : [];
                                let type = "new";
                                if (allQuizDetails.length > 0) {
                                  const allCovered = allQuizDetails.every(
                                    (q) => q.covered === true || q.covered === "True",
                                  );
                                  const someCovered = allQuizDetails.some(
                                    (q) => q.covered === true || q.covered === "True",
                                  );
                                  if (allCovered) {
                                    type = "complete";
                                  } else if (someCovered) {
                                    type = "partial";
                                  } else {
                                    type = "none";
                                  }
                                }
                                return (
                                  <QuestionRegenerateForm
                                    type={type}
                                    id={apiResponse.id}
                                    onSubmit={() => {
                                      setApiResponse((prev) => ({
                                        ...prev,
                                        generated_question: true,
                                      }));
                                      setActiveQuestionTab("new_questions");
                                      regeneratedQuestionsRef.current?.loadData();
                                    }}
                                  />
                                );
                              })()}
                              {apiResponse.questions?.map((item, index) =>
                                item.quiz_details?.map((element, indx) => (
                                  <div key={`${index}-${indx}`}>
                                    <h6>
                                      {element.question_text} {`( ${element.question_name} )`}
                                    </h6>
                                    <p className="mb-5">
                                      <b style={{ fontStyle: "italic" }}>Covered: </b>
                                      {element.covered || element.covered == "True" ? "Yes" : "No"}
                                    </p>
                                  </div>
                                )),
                              )}
                            </>
                          )}
                        </>
                      )}
                    </div>
                  ) : apiResponse.search_type == 2 ? (
                    <p>
                      Transcript generation is in progress. Once completed, AI will generate the
                      corresponding questions and answers.
                    </p>
                  ) : (
                    <p>
                      Transcript generation is in progress. Once completed, AI will evaluate the
                      questions are covered or not.
                    </p>
                  )}
                </Tab>
                <Tab eventKey="aiComment" title="AI Comment">
                  <div className="content text-start mt-2">
                    <label>
                      <b>Summary : </b>
                    </label>
                    <p>
                      {apiResponse.summary
                        ? apiResponse.summary
                        : "Transcript generation is in progress. Once completed, AI will give the feedback summary."}
                    </p>
                  </div>
                </Tab>
                {apiResponse.rating && (
                  <Tab eventKey="airating" title="AI Rating">
                    <div className="content text-start mt-2">
                      <label>
                        <b>Rating : </b>
                      </label>
                      <span>{apiResponse.rating ? apiResponse.rating : ""}</span>
                    </div>
                  </Tab>
                )}
                <Tab eventKey="transcript" title="Transcript">
                  <div className="content text-start mt-2">
                    <p>
                      <label>
                        <b>Transcript : </b>
                      </label>
                      {apiResponse.transcript ? (
                        <>
                          {visibleCharacters >= apiResponse.transcript.length
                            ? apiResponse.transcript
                            : `${apiResponse.transcript.slice(0, visibleCharacters)}...`}
                          {visibleCharacters < apiResponse.transcript.length && (
                            <span
                              onClick={handleShowMore(apiResponse.transcript.length)}
                              style={{ color: "blue", cursor: "pointer" }}
                            >
                              Show more
                            </span>
                          )}
                        </>
                      ) : (
                        "Transcript generation is in progress."
                      )}
                    </p>
                  </div>
                </Tab>
                {/* <Tab eventKey="replacement" title="Replacemant">
                <div className="content text-start mt-2">
                  <p><b>Rating : </b>{apiResponse.rating ? apiResponse.rating : "In progress.."}</p>
                  <button className="btn btn-primary" onClick={closePopup}>Replace with this video</button>
                  </div>
                </Tab> */}
              </Tabs>
            </Modal.Body>
            <div className="modal-footer">
              <button className="footer-close btn btn-primary" onClick={closePopup}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      {deleteModel && (
        <Modal
          show={deleteModel}
          onHide={() => setDeleteModel(false)}
          className="modal-block"
          centered
          size="lg"
        >
          <Modal.Header>
            <h5>Confirmation</h5>
          </Modal.Header>
          <Modal.Body>Are you sure do you want to delete?</Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                handleDelete();
              }}
            >
              Yes
            </Button>
            <Button variant="primary" onClick={() => setDeleteModel(false)}>
              No
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </Container>
  );
};
export default SavedListTable;
